import axios from "axios"
import { trackPromise } from "react-promise-tracker"
import ActionTypes from "redux/ActionTypes"

export const setLocalize = (key, data) => ({
    type : ActionTypes.SET_LOCALIZE,
    payload: {
		key,
		data,
	},   
})

const cdn = axios.create({
	baseURL: `https://cdngarenanow-a.akamaihd.net/devid/${process.env.REACT_APP_LOCALIZE_NAME}/`,
	withCredentials: false,
})

const common = axios.create({
	baseURL: `https://cdngarenanow-a.akamaihd.net/webid/TranslateCommon/`,
	withCredentials: false,
})

/**
 *
 * Example of how to implement multi language
 *
 */
 export const getLocalize = (lang = 'IND') => {
	return async (dispatch) => {
		try {
            const mainLocalize = await trackPromise(cdn.get(`${lang}.json?${Math.random() * 10000}`))
            const commonLocalize = await trackPromise(common.get(
                `${lang}.json?${Math.floor(Math.random() * 10000)}`
            ))
            dispatch(setLocalize('event', {...mainLocalize.data,  ...commonLocalize.data}));
        } catch(err) {
            
        }
	}
}
